import { useEffect, type ReactNode } from "react";

import { usePublicSettingsQuery } from "@/api/settings";

export const DEFAULT_BRAND_PRIMARY = "#1A56DB";
export const DEFAULT_BRAND_ACCENT = "#c33434";

interface TenantThemeProps {
  children: ReactNode;
  /** Testler / /dev/kit icin: sorguyu atlayip dogrudan renk vermek istersen. */
  primaryColor?: string;
  accentColor?: string;
  /** Ayar sorgusunu calistir mi (yalniz oturum acilmis + tenant secilmisse true olmali). */
  enabled?: boolean;
}

function asColor(value: unknown, fallback: string): string {
  return typeof value === "string" && /^#[0-9a-fA-F]{3,8}$/.test(value) ? value : fallback;
}

/**
 * Tek AsakAI markasi + tenant basina iki renk vurgusu (kullanici karari,
 * docs/faz5-arayuz-spec.md basligi). `GET /api/v2/tenant/public-settings`
 * (P5-F4 madde 1 — HER tenant_user icin, tenant_admin sarti YOK; eski
 * `/tenant/settings` 403 verirdi) icindeki `brand.primary_color` /
 * `brand.accent_color` degerlerini `--brand-primary` / `--brand-accent` CSS
 * degiskenlerine yazar; Tailwind `brand-primary` / `brand-accent` renkleri bu
 * degiskenlere baglidir. Uc henuz backend'de yoksa (404) ya da baska bir
 * hata donerse sessizce varsayilan marka renklerine duser — arayuzde HATA
 * GOSTERILMEZ (bkz. usePublicSettingsQuery: retry:false).
 */
export function TenantTheme({ children, primaryColor, accentColor, enabled = true }: TenantThemeProps) {
  const settingsQuery = usePublicSettingsQuery(enabled && !primaryColor && !accentColor);

  const primary = primaryColor ?? asColor(settingsQuery.data?.["brand.primary_color"], DEFAULT_BRAND_PRIMARY);
  const accent = accentColor ?? asColor(settingsQuery.data?.["brand.accent_color"], DEFAULT_BRAND_ACCENT);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--brand-primary", primary);
    root.style.setProperty("--brand-accent", accent);
    return () => {
      root.style.removeProperty("--brand-primary");
      root.style.removeProperty("--brand-accent");
    };
  }, [primary, accent]);

  return <>{children}</>;
}
